import React from 'react';
import { observer } from 'mobx-react-lite';
import { ChevronLeft, ChevronRight } from '@insurancemenu/imenu-components-lib/dist/icons';
import { FooterStyled, ContinueButtonsWrapperStyled, ActionButtonStyled } from './styles';
import {
  NAVIGATION_FOOTER_BACK_BTN_TEST_ID,
  NAVIGATION_FOOTER_SAVE_AND_CONTINUE_BTN_TEST_ID,
  NAVIGATION_FOOTER_SAVE_AND_RETURN_BTN_TEST_ID,
} from '../constants';

interface Props {
  allowSubmit: boolean;
  isLoading?: boolean;
  back: {
    text: string;
    handler: () => void;
  };
  saveAndReturn: {
    text: string;
    handler: () => Promise<void>;
  };
  saveAndContinue?: {
    text: string;
    handler: () => Promise<void>;
  };
}

const NavigationActionFooter: React.FC<Props> = observer(
  ({ allowSubmit, isLoading = false, back, saveAndReturn, saveAndContinue }) => {
    const isSubmitButtonDisabled = !allowSubmit || isLoading;
    return (
      <FooterStyled>
        <ActionButtonStyled
          type="outlined"
          size="large"
          width="24rem"
          onClick={back.handler}
          leftIconProp={<ChevronLeft />}
          data-test-id={NAVIGATION_FOOTER_BACK_BTN_TEST_ID}
        >
          {back.text}
        </ActionButtonStyled>
        <ContinueButtonsWrapperStyled>
          <ActionButtonStyled
            size="large"
            width="24rem"
            color="primary"
            type="outlined"
            onClick={saveAndReturn.handler}
            disabled={isSubmitButtonDisabled}
            leftIconProp={<ChevronLeft />}
            data-test-id={NAVIGATION_FOOTER_SAVE_AND_RETURN_BTN_TEST_ID}
          >
            {saveAndReturn.text}
          </ActionButtonStyled>
          {saveAndContinue && (
            <ActionButtonStyled
              size="large"
              width="24rem"
              color="primary"
              onClick={saveAndContinue.handler}
              rightIconProp={<ChevronRight />}
              disabled={isSubmitButtonDisabled}
              data-test-id={NAVIGATION_FOOTER_SAVE_AND_CONTINUE_BTN_TEST_ID}
            >
              {saveAndContinue.text}
            </ActionButtonStyled>
          )}
        </ContinueButtonsWrapperStyled>
      </FooterStyled>
    );
  },
);

export default NavigationActionFooter;
